
<div>
  <dropzone
    v-if="shouldShowDropzone"
    :url="url"
    ref="dropzone"
    :data-dropzone-id="dropzoneId"
    :name="name"
    :property-client-id="propertyClientId"
    :upload-multiple="false"
    :autoProcessQueue="false"
    :maxFiles="maxFiles"
    :disabled="disabled"
    v-tooltip.wrap="tooltipIfDisabled"
    :class="commonEntriesPropertiesCssClasses"
    v-on:file-added="increaseCountForValidation"
    v-on:file-removed="decreaseCountForValidation"
  >
  </dropzone>

  <div class="row">
    <ul class="upload-list col-12">
      <li v-for="upload in uploads" :key="upload.id">
        <a :href="pathForUpload(upload)" target="_blank">{{ upload.filename }} ({{ fileSizeMB(upload) }})</a>
        <div class="cta">
          <a :href="pathForUpload(upload)" target="_blank" class="open">open/download</a>
          <a v-if="!disabled"
            class="delete"
            @click.prevent="queueUploadForDeletion(upload)"
            :class="commonEntriesPropertiesCssClasses"
            :disabled="disabled"
            v-tooltip="tooltipIfDisabled"
          >
            delete
          </a>
        </div>
      </li>
    </ul>
  </div>
</div>
